import { render } from "./NotFound.vue?vue&type=template&id=3a86191f"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a86191f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a86191f', __exports__)) {
    api.reload('3a86191f', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=3a86191f", () => {
    api.rerender('3a86191f', render)
  })

}


export default __exports__